import React, { Component } from 'react';
import Firebase from 'firebase';
import Connector from '../../data/Connector';
import HelperBusiness from '../../helper/Business';
import * as ROUTES from '../../constants/routes';
import { Link, withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import EventEmitter from '../../helper/Emitter';
import Navigation from '../../components/Navigation';
import Header from '../../components/Headers/form';
import ListEmpty from '../../components/List/empty';
import ModalClients from '../../components/Modals/clients';
import ModalStats from '../../components/Modals/stats';
import ModalMessageSimple from '../../components/Modals/message-simple';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class DocumentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: null,
      clients: global.clients,
      itemStats: null,
      showModalDelete: false,
      showModalResponse: false,
      showModalSend: false,
      showModalStats: false,
    };
  }


  componentDidMount() {
    HelperPage.initialize('Form - PT Mate', ROUTES.ADMINDOC)
    HelperPage.checkMessage()
    this._isMounted = true

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('clientsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('formsLoaded', (event) => this.configureData())
    this.configureData()
  }


  componentWillUnmount() {
    this._isMounted = false
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('clientsLoaded', () => {})
    EventEmitter.unsubscribe('formsLoaded', () => {})
  }


  configureData() {
    if(this._isMounted) {
      var form = null
      var arr = this.props.location.pathname.split('/')
      for(var item of global.forms) {
        if(item.id === arr[arr.length-1]) {
          form = item
        }
      }
      this.setState({
        item: form
      })
      this.setClients('')
    }
  }


  setClients(type) {
    var tmp = []
    if(type !== 'response' || this.state.item.data.pre) {
      tmp = global.clients
    } else if(type === 'response' && !this.state.item.data.pre) {
      for(var item of global.clients) {
        for(var form of item.forms) {
          if(form.id === this.state.item.id) {
            tmp.push(item)
          }
        }
      }
    }
    this.setState({
      clients: tmp
    })
  }


  duplicateForm() {
    var obj = Firebase.database().ref('/forms/').push()
    Firebase.database().ref('/forms/'+global.uid+'/'+obj.key).update(
      this.state.item.data
    ).then((data)=>{
      Firebase.database().ref('/forms/'+global.uid+'/'+obj.key).update({
        name: this.state.item.data.name+' ('+lang.t('messaging:label.copy')+')',
        pre: false
      })
      EventEmitter.dispatch('showMessage', lang.t('messaging:message.formduplicated'));
    }).catch((error)=>{
      EventEmitter.dispatch('showMessageError', error.message);
    })
  }



  // Modals ------------------------------------------------------------



  showResponses() {
    this.setClients('response')
    this.setState({
      showModalResponse: true
    })
  }


  showSend() {
    this.setClients('')
    this.setState({
      showModalSend: true
    })
  }


  showStats(item) {
    this.setState({
      itemStats: item,
      showModalStats: true
    })
  }


  hideModals() {
    this.setState({
      showModalDelete: false,
      showModalResponse: false,
      showModalStats: false,
      showModalSend: false
    })
  }


  selectClient(item) {
    this.hideModals()
    this.props.history.push('/clients/'+item.id+'/form/'+this.state.item.id)
  }


  sendForm(list) {
    if(list.length > 0) {
      for(var item of list) {
        /*Firebase.database().ref('/clients/'+global.uid+'/'+item+'/forms/'+this.state.item.id).update(
          this.state.item.data
        ).then((data)=>{
          //
        }).catch((error)=>{
          EventEmitter.dispatch('showMessageError', error.message);
        })*/
        this.sendingForm(item)
        var tokens = []
        for(var item2 of global.clients) {
          if(item === item2.id && item2.data.pushToken !== undefined && item2.data.pushToken !== '') {
            tokens.push(item2.data.pushToken)
          }
        }
        if(tokens.length > 0) {
          Connector.sendPushNotification('',lang.t('messaging:push.newform.title'), global.userName+lang.t('messaging:push.newform.text'), 'form', this.state.item.id, tokens)
        }
      }
      this.hideModals()
      EventEmitter.dispatch('showMessage', lang.t('messaging:message.formsent'));
    }
  }


  async sendingForm(item) {
    await Firebase.database().ref('/clients/'+global.uid+'/'+item+'/forms/'+this.state.item.id).update(
      this.state.item.data
    ).then((data)=>{
      //
    }).catch((error)=>{
      EventEmitter.dispatch('showMessageError', error.message);
    })
  }


  deleteForm() {
    this.hideModals()
    if(this.state.item.data.pre) {
      Firebase.database().ref('/spaces/'+global.uid).update({
        preExercise: ''
      })
    }
    Firebase.database().ref('/forms/'+global.uid+'/'+this.state.item.id).remove()
    .then((data)=>{
      global.message = lang.t('messaging:message.formdeleted')
      this.props.history.push(ROUTES.ADMINDOC)
    }).catch((error)=>{
      EventEmitter.dispatch('showMessageError', error.message);
    })
  }



  // Display stuff ------------------------------------------------------------



  renderLock() {
    if(this.state.item.data.lock !== undefined) {
      if(this.state.item.data.lock) {
        return (
          <span>{lang.t('admin:label.forms.info2')}</span>
        )
      }
    }
  }


  renderTop() {
    if(this.state.item.data.pre) {
      return (
        <div className="infobox green mb-30 large" style={{marginBottom: 20}}>
          <p className="mb-10">{lang.t('admin:label.forms.infopre')}</p>
          <button className="btn tertiary" onClick={() => this.showResponses()}>{lang.t('admin:button.viewresponses')}</button>
          <div className="clear"></div>
        </div>
      )
    } else {
      return (
        <div className="infobox mb-30 large">
          <p className="mb-10">{lang.t('admin:label.forms.info1')} {this.renderLock()}</p>
          <button className="btn tertiary" onClick={() => this.showResponses()}>{lang.t('admin:button.viewresponses')}</button>
          <div className="clear"></div>
        </div>
      )
    }
  }


  renderQuestion(item) {
    if(item.data.type === 'header') {
      return (
        <div className="listheader">
          <h4>{item.data.label}</h4>
          <div className="clear"></div>
        </div>
      )
    } else if(item.data.type === 'paragraph') {
      return (
        <div className="mb-40">
          <p style={{whiteSpace: 'pre-wrap'}}>{item.data.label}</p>
        </div>
      )
    } else if(item.data.type === 'text') {
      return (
        <div className="mb-40">
          <p className="lft" style={{width: 'calc(100% - 34px)'}}>{item.data.label}</p>
          <div className="icontoggle stats rgt" onClick={() => this.showStats(item)}></div>
          <div className="clear mb-10"></div>
          <span className="pill primary">{lang.t('admin:label.forms.freetext')}</span>
        </div>
      )
    } else if(item.data.type === 'yesno') {
      return (
        <div className="mb-40">
          <p className="lft" style={{width: 'calc(100% - 34px)'}}>{item.data.label}</p>
          <div className="icontoggle stats rgt" onClick={() => this.showStats(item)}></div>
          <div className="clear mb-10"></div>
          <span className="pill primary">{item.data.answer1 ? lang.t('admin:label.forms.yes')+' > '+lang.t('admin:label.forms.providedetails') : lang.t('admin:label.forms.yes')}</span>&nbsp;
          <span className="pill primary">{item.data.answer2 ? lang.t('admin:label.forms.no')+' > '+lang.t('admin:label.forms.providedetails') : lang.t('admin:label.forms.no')}</span>
        </div>
      )
    } else if(item.data.type === 'selection') {
      return (
        <div>
          <div className="mb-40">
            <p className="lft" style={{width: 'calc(100% - 34px)'}}>{item.data.label}</p>
            <div className="icontoggle stats rgt" onClick={() => this.showStats(item)}></div>
            <div className="clear mb-10"></div>
            <span className="pill primary">{item.data.multiple ? lang.t('admin:label.forms.multipleselection') : lang.t('admin:label.forms.singleselection')}</span>
            <div className="sv-10"></div>
            <ul className="basic">
              {item.data.options.map((option) => (
                <li>{option}</li>
              ))}
            </ul>
          </div>
          <div className="clear sv-20 hide768"></div>
        </div>
      )
    } else if(item.data.type === 'rating') {
      return (
        <div>
          <div className="mb-40">
            <p className="lft" style={{width: 'calc(100% - 34px)'}}>{item.data.label}</p>
            <div className="icontoggle stats rgt" onClick={() => this.showStats(item)}></div>
            <div className="clear mb-10"></div>
            <span className="pill primary">{lang.t('admin:label.forms.rating')} {item.data.num}</span>
          </div>
        </div>
      )
    }
  }


  renderButtons() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.item.data.pre) {
        return (
          <div>
            <div className="col-4">
              <button className="btn secondary" onClick={() => this.duplicateForm()}>{lang.t('common:button.duplicate')}</button>
              <div className="sv-20"></div>
            </div>
            <div className="col-4">
              <Link to={'/admin/documents/form/'+this.state.item.id+'/edit'} className="btn secondary">{lang.t('common:button.edit')}</Link>
              <div className="sv-20"></div>
            </div>
            <div className="col-4">
              <a href={'/admin/documents/print-form/'+this.state.item.id} target="_blank" className="btn secondary">{lang.t('program:button.print')}</a>
            </div>
            <div className="clear sv-20"></div>
            <button className="btn tertiary width-12" onClick={() => this.setState({showModalDelete: true})}>{lang.t('common:button.delete')}</button>
          </div>
        )
      } else {
        return (
          <div>
            <div className="col-3">
              <button className="btn primary" onClick={() => this.showSend()}>{lang.t('admin:button.sendtomyclients')}</button>
            </div>
            <div className="col-3">
              <button className="btn secondary" onClick={() => this.duplicateForm()}>{lang.t('common:button.duplicate')}</button>
            </div>
            <div className="col-3">
              <Link to={'/admin/documents/form/'+this.state.item.id+'/edit'} className="btn secondary">{lang.t('common:button.edit')}</Link>
            </div>
            <div className="col-3">
              <a href={'/admin/documents/print-form/'+this.state.item.id} target="_blank" className="btn secondary">{lang.t('program:button.print')}</a>
            </div>
            <div className="clear sv-20"></div>
            <button className="btn tertiary width-12" onClick={() => this.setState({showModalDelete: true})}>{lang.t('common:button.delete')}</button>
          </div>
        )
      }
    }
  }


  renderBase() {
    if(HelperBusiness.getRoleIncl('trainer,admin,finance,cs')) {
      if(this.state.item === null) {
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content"></div>
            <Header title={lang.t('admin:title.form')} link={ROUTES.ADMINDOC}/>
            <Navigation active='admin' />
          </div>
        )
      } else {
        var list = this.state.item.sections
        list.sort((a, b) => a.data.seq - b.data.seq)
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content form-sidebar">
              {this.renderTop()}
              {list.map((item) => (
                <div className="col-12">
                  {this.renderQuestion(item)}
                </div>
              ))}
              <div className="clear sv-30"></div>
              {this.renderButtons()}
              <div className="clear sv-40"></div>
            </div>
            <Header title={this.state.item.data.name} link={ROUTES.ADMINDOC}/>
            <Navigation active='admin' />
            <ModalClients clients={this.state.clients} title={lang.t('modals:clients.title.viewresponses')} object={this.state.item} data='response' show={this.state.showModalResponse} onHide={() => this.hideModals()} clickElement={(event) => this.selectClient(event)}/>
            <ModalClients clients={this.state.clients} title={lang.t('modals:clients.title.sendform')} multiple={true} object={this.state.item} data='sendform' show={this.state.showModalSend} onHide={() => this.hideModals()} clickMainButton={(event) => this.sendForm(event)}/>
            <ModalStats id={this.state.item.id} item={this.state.itemStats} show={this.state.showModalStats} onHide={() => this.hideModals()}/>
            <ModalMessageSimple type={this.state.item.data.pre ? 'deleteformpre' : 'deleteform'} show={this.state.showModalDelete} onHide={() => this.hideModals()} clickMainButton={() => this.deleteForm()}/>
          </div>
        )
      }
    } else {
      return (
        <div className={'theme-'+global.spaceTheme}>
          <div className="content">
            <ListEmpty id='forms-locked'/>
          </div>
          <Header title={lang.t('admin:title.form')} link='/overview'/>
          <Navigation active='admin' />
        </div>
      )
    }
    
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['admin','common','header','modals','messaging'])(withRouter(withAuthorization(condition)(DocumentPage)));